import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import DefaultHeader from '../../container/default-layout/header';
import DefaultSideBar from '../../container/default-layout/side.bar';
import { DefaultFooter } from '../../container/default-layout/footer';
import AppService from "../../../services/app.service";
import Loader from '../../../components/loader';
import AlertDialogSlide from '../../../components/deleteModal';
import { formatDateToDisplay } from "../../../utils/dateUtils";
import Table from "../../../components/Table";
import { TableState } from "../../../types/table";
import Select from 'react-select';
import auth from "../../../services/auth";
import SnackbarAlert from "../../../components/SnackBarAlert";

/**
 * Class Management list (Standard + Self-Serve).
 *
 * Type column uses `enrollmentMode` from GET /api/classes/ByAccount/{accId} (0 = all accounts).
 * Super Admin can filter by account, same as User Management. Self-Serve rows carry `landingUrl`
 * for the copy button.
 * Add Class chooser → Standard (`/classes/add`) or Self-Serve (`/classes/self-serve/add`).
 * Edit/delete routes branch on Type. Self-Serve details: docs/edsims/modules/21-self-serve-enrollment.md
 */

type ClassesState = TableState & {
  deleteEnrollmentMode: string;
  showAddChooser: boolean;
  loading: boolean;
  /** Account filter; 0 = all accounts. */
  accId: number;
  accountOption: any;
  accountList: any[];
  /** Snackbar shown after the copy-landing-URL button. */
  alert: boolean;
  alertProps: { msg: string; type: string };
};

let classess = '';

class Classes extends React.Component<
    any,
    ClassesState
> {

    readonly state: ClassesState = {
        columns: [
            {
                dataField: "value",
                text: "ID",
                sort: true,
                classes: "content-body",
                headerStyle:{minWidth:50},
                headerClasses: "table_header_color",
                align: "left",
            }, {
                dataField: "label",
                text: "Name",
                sort: true,
                classes: "content-body",
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "description",
                text: "Comments",
                sort: true,
                classes: "paragraph-in-table content-body",
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "enrollmentMode",
                text: "Type",
                classes: "text-center content-body",
                headerStyle: { width: 130 },
                headerClasses: "text-center table_header_color",
                align: "center",
                formatter: (cell, record) => (
                    <Fragment>
                        {record.enrollmentMode === "SELF_SERVE"
                            ? <span className="badge badge-info">Self-Serve</span>
                            : <span className="badge badge-secondary">Standard</span>}
                    </Fragment>
                )
            },
            {
                dataField: "active",
                text: "Status",
                classes: "text-center content-body",
                headerStyle:{width:120},
                headerClasses: "text-center",
                align: "center",
                formatter:(cell, record) => {
                    return (
                        <Fragment>
                            {!record.active && <label>Disabled</label>}
                            {record.active && <label>Active</label>}
                        </Fragment>
                    );
                }
            },
            {
                dataField: "expiry",
                text: "Expiration Date",
                sort: true,
                classes: "expiry text-center content-body",
                headerStyle: {minWidth: 170},
                headerClasses: "text-center table_header_color",
                align: "center",
                formatter:(cell, record) => {
                    return (
                        <Fragment>
                            {record.expiry == null || record.expiry == '' ? 'MM/DD/YYYY' : formatDateToDisplay(record.expiry)}
                        </Fragment>
                    )
                }
            },
            {
                dataField: "action",
                text: "Action",
                classes: "action",
                headerStyle: {width: 190},
                headerClasses: "text-center",
                align: "left",
                formatter:(cell, record) => {
                    if (record.enrollmentMode === "SELF_SERVE") {
                        return (
                            <Fragment>
                                {record.landingUrl && (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm buttons"
                                        onClick={() => this.copyLandingUrl(record.landingUrl)}
                                        style={{ marginRight: '5px' }}>
                                        <i className="fa fa-link" title="Copy Landing URL" />
                                    </button>
                                )}
                                <Link
                                    className="btn btn-primary btn-sm"
                                    to={`/classes/self-serve/edit/${record.value}`}
                                    style={{ marginRight: '5px' }}>
                                    <i className="fa fa-edit" title="Edit Class" />
                                </Link>
                                <button
                                    className="btn btn-danger btn-sm buttons"
                                    onClick={() => this.deleteRecord(record.value, record.label, "SELF_SERVE")}
                                    style={{ marginRight: '5px' }}>
                                    <i className="fa fa-trash" title="Delete Self-Serve Class" />
                                </button>
                            </Fragment>
                        );
                    }
                    return (
                        <Fragment>
                            <Link
                                className="btn btn-primary btn-sm"
                                to={`classes/edit/${record.value}`}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-edit" title="Edit Class" />
                            </Link>
                            <button
                                className="btn btn-danger btn-sm buttons"
                                onClick={() => this.deleteRecord(record.value, record.label, "STANDARD")}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-trash" title="Delete Class" />
                            </button>
                        </Fragment>
                    );
                }
            }
        ],
        data: [],
        value: 0,
        deleteEnrollmentMode: "STANDARD",
        isShowingModal: false,
        showAddChooser: false,
        loading: false,
        accId: 0,
        accountOption: null,
        accountList: [],
        alert: false,
        alertProps: { msg: "", type: "success" },
        totalRecords: 0,
        sort: {
            column: "expiry",
            order: "desc"
        }
    };

    role;

    handleClick = () => this.setState({ isShowingModal: true })
    handleClose = () => this.setState({ isShowingModal: false })

    openAddChooser = () => this.setState({ showAddChooser: true })
    closeAddChooser = () => this.setState({ showAddChooser: false })

    deleteRecord(record, label, enrollmentMode = "STANDARD") {
        this.setState({ value: record, deleteEnrollmentMode: enrollmentMode });
        classess = label;
        this.handleClick();
    }

    handleProcess = async () => {
        this.handleClose();
        this.setState({ loading: true });
        try {
            if (this.state.deleteEnrollmentMode === "SELF_SERVE") {
                const res = await AppService.delete(this.state.value, "ss-classes");
                if (res.status === 200) {
                    await this.loadData(this.firstPageUrl(this.state.accId));
                    return;
                }
            } else {
                const classes = await AppService.delete(this.state.value, "classes");
                if (classes.status === 200) {
                    this.setState({ data: classes.data });
                }
            }
        } catch (e) {
            // Keep the list as-is; finally still clears the loader.
        } finally {
            this.setState({ loading: false });
        }
    }

    loadData = async (queryString: string) => {
        this.setState({ loading: true });
        const classes = await AppService.getAll(queryString);
        this.setState({ data: classes.data.classes, totalRecords: classes.data.totalRecords });
        this.setState({ loading: false });
    }

    /** List endpoint for the selected account (0 = all accounts). */
    listUrl = (accId: number) => `classes/ByAccount/${accId}`;

    firstPageUrl = (accId: number) => {
        const sortColumn = this.state.sort?.column || "expiry";
        const sortOrder = this.state.sort?.order || "desc";
        return `${this.listUrl(accId)}?filter_value=&page_number=1&page_size=10&sort_column=${sortColumn}&sort_order=${sortOrder}`;
    }

    loadAccounts = async () => {
        const accounts = await AppService.getAll('accounts/list');
        const list = [{ value: 0, label: "All" }, ...(accounts.data || [])];
        this.setState({ accountList: list, accountOption: list[0] });
    }

    handleAccountChange = (option) => {
        this.setState({ accId: option.value, accountOption: option });
        this.loadData(this.firstPageUrl(option.value));
    }

    closeSnackBarAlert = () => this.setState({ alert: false });

    copyLandingUrl = async (url: string) => {
        let alertProps = { msg: "Landing URL copied to clipboard successfully!", type: "success" };
        try {
            await navigator.clipboard.writeText(url);
        } catch (e) {
            alertProps = { msg: "Could not copy the landing URL.", type: "error" };
        }
        this.setState({ alert: true, alertProps });
    }

    componentWillMount = () => {
        this.role = auth.getUserRole();
        if (this.role === 'Role_Super_Admin') {
            this.loadAccounts();
        }
        this.loadData(this.firstPageUrl(0));
    }

    render() {

        return (
            <div>
                <div className="page">
                    <DefaultHeader history={this.props.history} />
                    <div className="page-content d-flex align-items-stretch fields-font">
                        <DefaultSideBar activeClassLink={true} />
                        <div className="content-inner">
                            <header className="page-header">
                                <div className="container-fluid">
                                    <h2 className="heading">Class Management</h2>
                                </div>
                            </header>
                            <div className="breadcrumb-holder container-fluid">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item breadcrumb-list"><Link to='/dashboard'>Dashboard</Link></li>
                                    <li className="breadcrumb-item active breadcrumb-list">Class Management</li>
                                </ul>
                            </div>
                            <section className="tables">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-close">
                                                    <div className="dropdown">
                                                        <a
                                                            className="dropdown-toggle"
                                                            href="#add-class"
                                                            onClick={(e) => { e.preventDefault(); this.openAddChooser(); }}
                                                        >
                                                            <i className="fas fa-plus" title='Add Class' />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="card-header d-flex align-items-center">
                                                    <h3 className="sub-heading">Classes</h3>
                                                </div>

                                                <div className="card-body">
                                                    {(this.role === 'Role_Super_Admin') &&
                                                        <div className="form-group row mb-4">
                                                            <label className="col-sm-3 form-control-label mt-2 content-body">Select Account: </label>
                                                            <div className="col-sm-9">
                                                                <Select name="accounts" aria-label="Select Account" isMulti={false} options={this.state.accountList} value={this.state.accountOption} className="basic-multi-select content-body" onChange={this.handleAccountChange} />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="table-responsive data-table-wrapper table-heading">
                                                        <Table
                                                            data={this.state.data}
                                                            columns={this.state.columns}
                                                            total={this.state.totalRecords}
                                                            apiUrl={this.listUrl(this.state.accId)}
                                                            getData={this.loadData}
                                                            defaultSort={this.state.sort.column}
                                                            defaultOrder={this.state.sort.order}
                                                            id="value"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <DefaultFooter />
                            {(this.state.loading) && <div className="overlay">
                                <Loader loading={this.state.loading} />
                            </div>}
                        </div>
                    </div>
                </div>
                <AlertDialogSlide
                    show={this.state.isShowingModal}
                    handleNo={this.handleClose}
                    handleYes={this.handleProcess}
                    title="Delete Class"
                >
                    <p className="fields-font">
                        Are you sure you want to delete the class <span className="span">{classess}</span> ?
                        {this.state.deleteEnrollmentMode === "SELF_SERVE" && (
                            <>
                                <br />
                                This action will revoke all access codes generated for this class.
                            </>
                        )}
                    </p>
                </AlertDialogSlide>
                {this.state.alert && <SnackbarAlert {...this.state.alertProps} openAlert={this.state.alert} setOpenAlert={this.closeSnackBarAlert} />}
                {this.state.showAddChooser && (
                    <div
                        className="overlay"
                        style={{ background: "rgba(0,0,0,0.4)", zIndex: 1050 }}
                        onClick={this.closeAddChooser}
                    >
                        <div
                            className="card fields-font"
                            style={{ maxWidth: 520, margin: "8% auto", padding: 24 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h3 className="sub-heading">Add Class</h3>
                            <p>Choose how you want to create this class.</p>
                            <Link
                                to="/classes/add"
                                className="btn btn-primary btn-block mb-2"
                                onClick={this.closeAddChooser}
                            >
                                Standard class (manual setup)
                            </Link>
                            <small className="text-muted d-block mb-3">
                                Create the class, then add students and send simulation links manually.
                            </small>
                            <Link
                                to="/classes/self-serve/add"
                                className="btn btn-outline-primary btn-block mb-2"
                                onClick={this.closeAddChooser}
                            >
                                Self-serve enrollment class
                            </Link>
                            <small className="text-muted d-block mb-3">
                                Students self-register on a public landing page (pay or access code); provisioning is automatic.
                            </small>
                            <button className="btn btn-secondary btn-block" onClick={this.closeAddChooser}>
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
            </div>

        );
    }

}

export default Classes;
